import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetWaybillParams,
    GetWaybillsResponse,
    GetWaybillDetailsResponse,
    GetWaybillsStatitcResponse,
    SendRequestForPaymentPayload
} from './types/waybill.types'

type ApiGetWaybillsResponse = Promise<AxiosResponse<GetWaybillsResponse>>
type ApiGetWaybillDetailsResponse = Promise<AxiosResponse<GetWaybillDetailsResponse>>
type ApiGetWaybillsStatistic = Promise<AxiosResponse<GetWaybillsStatitcResponse>>
type ApiExportWaybillsResponse = Promise<AxiosResponse<Blob>>
type ApiSendOnRequestForPaymentResponse = Promise<AxiosResponse<void>>

export function getWaybills(params: GetWaybillParams): ApiGetWaybillsResponse {
    return http.get('/dispatcher/api/waybills', { params })
}

export function getWaybillDetails(waybillId: number): ApiGetWaybillDetailsResponse {
    return http.get(`/dispatcher/api/waybills/${waybillId}`)
}

export function getWaybillsStatistic(): ApiGetWaybillsStatistic {
    return http.get('/dispatcher/api/waybills-count')
}

export function exportWaybills(params: GetWaybillParams): ApiExportWaybillsResponse {
    return http.get('/dispatcher/api/waybills/export', { params, responseType: 'blob' })
}

export function sendOnRequestForPayment(waybillId: number, payload: SendRequestForPaymentPayload): ApiSendOnRequestForPaymentResponse {
    return http.post(`/dispatcher/api/waybills/${waybillId}/send`, payload)
}

export default {
    getWaybills,
    getWaybillDetails,
    getWaybillsStatistic,
    exportWaybills,
    sendOnRequestForPayment
}
